import {
  CustomDashboardsInfoChart,
  OS_LABEL,
  SHORT_LINK_GROUP_BY,
  WidgetChartType,
  WidgetGroupBy,
} from 'emma-common-ts/emma';
import { sortBy } from 'lodash';

export function switchWidget(one: CustomDashboardsInfoChart, two: CustomDashboardsInfoChart) {
  const { index } = one;
  one.index = two.index;
  two.index = index;
}

export function calculateAddWidgets(widgets: CustomDashboardsInfoChart[]) {
  const countSingle = widgets.reduce((acc, w) => (acc += w.fullSize || w.type === 'add' ? 0 : 1), 0);
  return 1 + (countSingle % 2 ? 0 : 1);
}

export const getDefaultWidget = (
  widget: Partial<CustomDashboardsInfoChart> = {}
): CustomDashboardsInfoChart => ({
  id: `${Math.floor(Math.random() * 1000)}_${Date.now()}`,
  description: '',
  filter: { os: null, country: null, campaign: null, source: null },
  groupBy: null,
  subGroupBy: null,
  index: undefined,
  kpi: ['installs'],
  title: '',
  type: 'add',
  layout: 'chart-only',
  ...widget,
});

export function getAddWidgets(widgets: CustomDashboardsInfoChart[], isEdit = false) {
  const totalAdd = isEdit ? calculateAddWidgets(widgets) : 0;
  let countAdd = 0;
  const adds = [];
  if (totalAdd > 0) {
    // Keep LAST AddWidget
    const pureWidgets = widgets
      .slice(0)
      .reverse()
      .filter((w, i) => {
        if (w.type !== 'add') {
          return true;
        } else if (countAdd < totalAdd) {
          countAdd += 1;
          return true;
        }
        return false;
      })
      .reverse();
    if (countAdd < totalAdd) {
      let index = pureWidgets.length;
      while (countAdd < totalAdd) {
        adds.push(getDefaultWidget({ type: 'add', index }));
        index += 1;
        countAdd += 1;
      }
    }
  }
  return adds;
}

export function updateWidgetIndex(widgets: CustomDashboardsInfoChart[]) {
  return widgets.map((w, i) => {
    if (w.index !== i) {
      w.index = i;
    }
    return w;
  });
}

export function sortWidgetsBySpace(widgets: CustomDashboardsInfoChart[]) {
  let countSingles = 0;
  widgets.forEach((w, i, ws) => {
    if (!w.fullSize) {
      countSingles += 1;
    } else if (w.fullSize) {
      if (countSingles % 2) {
        const nextSingle = ws.find((wi, ii) => !wi.fullSize && ii > i);
        if (nextSingle) {
          switchWidget(w, nextSingle);
          countSingles -= 1;
        } else {
          const prevSingle = ws.find((wi, ii) => !wi.fullSize && ii < i);
          if (prevSingle) {
            switchWidget(w, prevSingle);
          }
        }
      }
    }
  });
  return sortBy(widgets, 'index');
}

export const getWidgetGroupBys = (): WidgetGroupBy[] => {
  return [
    { title: $localize`Fecha`, id: 'date' },
    { title: $localize`Sistema operativo`, id: SHORT_LINK_GROUP_BY.OS },
    { title: $localize`País`, id: SHORT_LINK_GROUP_BY.COUNTRY },
    { title: $localize`Campaña`, id: 'campaign' },
    { title: $localize`Tipo de fuente`, id: 'basic_source' },
    { title: $localize`Fuente de medios`, id: 'provider' },
    { title: $localize`Fuente`, id: 'source' },
  ];
};

export const getWidgetSubgroupBys = (): WidgetGroupBy[] => {
  return [
    { title: $localize`Sin subagrupar`, id: '' },
    { title: $localize`Sistema operativo`, id: SHORT_LINK_GROUP_BY.OS },
    { title: $localize`País`, id: SHORT_LINK_GROUP_BY.COUNTRY },
    { title: $localize`Campaña`, id: 'campaign' },
    { title: $localize`Tipo de fuente`, id: 'basic_source' },
    { title: $localize`Fuente de medios`, id: 'provider' },
  ];
};

export const getWidgetChartTypes = (): WidgetChartType[] => {
  return [
    { title: $localize`Gráfica de líneas`, type: 'lines' },
    { title: $localize`Gráfica de barras`, type: 'bars' },
    { title: $localize`Gráfica de donut`, type: 'donut' },
    // { title: $localize`Gráfica de embudo`, type: 'funnel' },
    // { title: this.i18n('Gráfica de embudo'), type: 'trapezoid' },
    { title: $localize`Contador`, type: 'value' },
  ];
};

export const getWidgetFilters = (): { [filter: string]: WidgetGroupBy[] } => {
  return {
    os: [
      { title: OS_LABEL.IOS, id: OS_LABEL.IOS.toLowerCase() },
      { title: OS_LABEL.ANDROID, id: OS_LABEL.ANDROID.toLowerCase() },
    ],
    source: [
      { title: $localize`Orgánico`, id: 'organic' },
      { title: $localize`No-orgánico`, id: 'paid' },
    ],
    country: [],
    campaign: [],
  };
};
